import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const FieldWrapper = styled.div<{ $disabled: boolean; $checked: boolean }>`
  width: ${({ theme }) => theme.spacing.x12};
  height: ${({ theme }) => theme.spacing.x6};
  border: 1px solid ${({ theme, $disabled }) => ($disabled ? theme.palette.border : theme.palette.secondary)};
  background: ${({ theme, $disabled, $checked }) =>
    $disabled ? theme.palette.lightGray : $checked ? theme.palette.secondary : theme.palette.secondaryLight};
  padding: 2px;
  border-radius: ${({ theme }) => theme.rounded.x4};
  transition: ease all 0.2s;
`;

export const Bullet = styled.div<{ $disabled: boolean; $checked: boolean }>`
  background: ${({ theme, $disabled }) => ($disabled ? theme.palette.whiteGray : theme.palette.white)};
  border-radius: ${({ theme }) => theme.rounded.full};
  transition: ease all 0.2s;
  transform: ${({ $checked }) => ($checked ? `translateX(26px)` : `translateX(0)`)};
  height: 100%;
  aspect-ratio: 1;
`;

export const Label = styled.label`
  font-size: ${({ theme }) => theme.fs.xs};
  font-weight: 500;
  color: ${({ theme }) => theme.palette.primary};
  margin-inline-end: ${({ theme }) => theme.spacing.x3};
`;
